var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Terms',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ")]},proxy:true}])},[[_c('div',{staticClass:"terms__content",domProps:{"innerHTML":_vm._s(_vm.content)}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }